import { Box, useToast } from '@chakra-ui/react';
import PrivateChannelArticleShortCard from 'presentation/components/modules/community/privateChannel/PrivateChannelArticleShortCard';
import Carousel from 'presentation/components/shared/Carousel/Carousel';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import mockPreview1 from 'assets/img/mock/articles/mock_article_preview_1.png';
import mockPreview2 from 'assets/img/mock/articles/mock_article_preview_2.png';
import PrivateChannelNoAccessCard from 'presentation/components/modules/community/privateChannel/PrivateChannelNoAccessCard';
import { usePrivateChannelLeadMutation } from 'rtkQuery/sharespro/queries/articles';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';

const PrivateChannelNoAccessContainer: FC = () => {
  const { t } = useTranslation();

  const [submitLead, { isLoading }] = usePrivateChannelLeadMutation();

  const toast = useToast();
  const toastErrorHandler = useToastError();

  return (
    <Box mb="20px">
      <GridHeading>{t('privateChannel')}</GridHeading>
      <Carousel
        scrollBy={352}
        itemsCount={3}
        viewportItemsCount={2}
        showControls
        scrollType="fixed"
      >
        <Box mr="15px">
          <PrivateChannelNoAccessCard
            onSubmit={() => {
              submitLead()
                .unwrap()
                .then(() => {
                  toast({
                    description: t('privateChannelRequestSent'),
                    status: 'success',
                    position: 'top-right',
                    isClosable: true,
                  });
                })
                .catch(toastErrorHandler);
            }}
          />
        </Box>
        <Box mr="15px" filter="blur(10px)">
          <PrivateChannelArticleShortCard
            inactive
            article={{
              id: 1,
              viewCount: 0,
              poll: null,
              isPrivate: true,
              gallery: [],
              name: 'Оптимизм AMD вокруг ИИ чипов подбадривает инвесторов',
              image: {
                url: mockPreview1,
                previewUrl: null,
                fileName: null,
                typeId: null,
                extension: null,
                size: null,
                width: null,
                height: null,
                previewHeight: null,
                previewWidth: null,
              },
              text: null,
              video: null,
              presentation: null,
              description: '',
              url: '',
              publicDate: new Date(2023, 11, 1),
              tags: ['Google', 'Nvidia', 'Илон'],
              reactions: [
                {
                  reaction: {
                    id: 1,
                    emoji: '👍',
                  },
                  total: 3,
                },
                {
                  reaction: {
                    id: 2,
                    emoji: '❤️',
                  },
                  total: 5,
                },
              ],
              commentsCount: 0,
              selectedReactionId: null,
              isCommentable: true,
              commentators: [],
              category: null,
            }}
          />
        </Box>
        <Box filter="blur(10px)">
          <PrivateChannelArticleShortCard
            inactive
            article={{
              id: 2,
              poll: null,
              isPrivate: true,
              viewCount: 0,
              gallery: [],
              name: 'Обзор фондового рынка США по итогам недели',
              image: {
                url: mockPreview2,
                previewUrl: null,
                fileName: null,
                typeId: null,
                extension: null,
                size: null,
                width: null,
                height: null,
                previewHeight: null,
                previewWidth: null,
              },
              text: null,
              video: null,
              presentation: null,
              description: '',
              url: '',
              publicDate: new Date(2024, 10, 1),
              tags: ['Ai', 'Маркетновост', 'Чипы'],
              reactions: [
                {
                  reaction: {
                    id: 1,
                    emoji: '👍',
                  },
                  total: 3,
                },
                {
                  reaction: {
                    id: 2,
                    emoji: '❤️',
                  },
                  total: 5,
                },
              ],
              commentsCount: 0,
              selectedReactionId: null,
              isCommentable: true,
              commentators: [],
              category: null,
            }}
          />
        </Box>
      </Carousel>
      <FullScreenLoader isLoading={isLoading} />
    </Box>
  );
};

export default PrivateChannelNoAccessContainer;
